<template>
  <Base :base-id="'lb-fa-cancel'" :base-class="'modal-sm'">
    <template #header>
      <h4 class="modal-title">是否取消fa points綁定？</h4>
    </template>
    <template #body>
      <p class="lh-15 mb-2">貼心提醒：</p>
      <p class="lh-15">
        消費及發放點數當下，若非綁定中狀態，將無法獲得訂單之點數回饋，也無法於下一次消費時進行點數折抵囉！若欲再次使用fa
        points，請重新完成綁定。相關服務辦法依照fa points服務條款為準。
      </p>
    </template>
    <template #footer>
      <button
        class="btn btn-outline-secondary w-100 btn-sm btn-confirm-cancel-bound"
        @click.prevent="cancelFaPoint"
      >
        取消綁定
      </button>
    </template>
  </Base>
</template>

<script setup>
import Base from '@global/components/common/modal/Base.vue';
import useFaPoint from '@global/composable/member/useFaPoint';

const { cancelFaPoint } = useFaPoint();
</script>
